    <ng-container [ngSwitch]="selectedOption">
      <lib-mobi-theme *ngSwitchCase="sideNavOptions.theme"  ></lib-mobi-theme>
      <lib-mobi-pages  *ngSwitchCase="sideNavOptions.pages" ></lib-mobi-pages>
      <lib-mobilesettings *ngSwitchCase="sideNavOptions.settings" ></lib-mobilesettings>
      <lib-entity *ngSwitchCase="sideNavOptions.entity"></lib-entity>
      <lib-api-calls *ngSwitchCase="sideNavOptions.api"></lib-api-calls>
      <app-mobile-analytics *ngSwitchCase="sideNavOptions.metrics"></app-mobile-analytics>
      <lib-entity-submission-details *ngSwitchCase="sideNavOptions.dataDownload"></lib-entity-submission-details>
      <div *ngSwitchDefault >
        Content for {{ selectedOption }} option goes here.
      </div>
    </ng-container>